module.exports = __webpack_public_path__ + "static/media/buy-online-add-thin-24-white.7ad98bd1.svg";